export type PayrollCategory = {
  number: string;
  verb: string;
  line: string;
  items: string[];
};

export const payrollCategories: PayrollCategory[] = [
  {
    number: "01",
    verb: "Run",
    line: "We process payroll for you — accurately and on schedule, across every state and entity.",
    items: ["Payroll processing", "Multi-state payroll", "Multi-entity payroll", "Tax filing and registration support", "Year-end support"],
  },
  {
    number: "02",
    verb: "Fix",
    line: "When payroll breaks, we step in, get people paid correctly, and find out why it happened.",
    items: ["Payroll 911 / emergency coverage", "Error correction and reconciliation", "Tax notices and registration problems", "Vendor escalation"],
  },
  {
    number: "03",
    verb: "Cover",
    line: "When your payroll person leaves, is out, or is stretched too thin, payroll still runs.",
    items: ["Backup and continuity coverage", "Interim coverage while you hire", "Payroll transitions", "Capturing what one person knows"],
  },
  {
    number: "04",
    verb: "Improve",
    line: "We find the errors, gaps, and manual steps — and fix them for good.",
    items: ["Payroll audits", "Process clean-up", "Calendars and checklists", "Less manual work"],
  },
  {
    number: "05",
    verb: "Lead",
    line: "Senior payroll leadership, part-time, without the cost of a full-time hire.",
    items: ["Fractional payroll leadership", "Vendor management", "Team structure and hiring support", "Reporting to finance leadership"],
  },
];
